import React, { ChangeEventHandler, FocusEventHandler, forwardRef, useEffect, useState } from 'react';
import { ITextFieldProps, TextField } from './TextField';
import { MATERIAL_ICONS, MATERIAL_ICONS_TYPES, MaterialIcon } from '../Icon/icons';

export interface IPasswordInputProps
  extends Omit<
    ITextFieldProps,
    'type' | 'startIcon' | 'startIconType' | 'startText' | 'endIcon' | 'endIconType' | 'endText' | 'onStartIconClick' | 'onEndIconClick'
  > {}

export const PasswordInput = forwardRef<HTMLInputElement, IPasswordInputProps>(({ onChange, onBlur, ...rest }, ref) => {
  const [icon, setIcon] = useState<MaterialIcon>(MATERIAL_ICONS.Lock);
  const [type, setType] = useState<'password' | 'text'>('password');

  const handleOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (!e.target.value) {
      setIcon(MATERIAL_ICONS.Lock);
    } else if (icon === MATERIAL_ICONS.Lock) {
      setIcon(MATERIAL_ICONS.VisibilityOff);
    }

    onChange?.(e);
  };

  const handleOnBlur: FocusEventHandler<HTMLInputElement> = (e) => {
    !e.target.value && setIcon(MATERIAL_ICONS.Lock);
    onBlur?.(e);
  };

  const toggleVisibility = () => {
    setIcon(icon === MATERIAL_ICONS.VisibilityOff ? MATERIAL_ICONS.Visibility : MATERIAL_ICONS.VisibilityOff);
  };

  useEffect(() => {
    setType(icon === MATERIAL_ICONS.Visibility ? `text` : `password`);
  }, [icon]);

  return (
    <TextField
      type={type}
      ref={ref}
      endIcon={icon}
      endIconType={MATERIAL_ICONS_TYPES.OUTLINE}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      onEndIconClick={icon === MATERIAL_ICONS.Lock ? undefined : toggleVisibility}
      {...rest}
    />
  );
});
